
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  StrategyRefusalReasonsInner,
} from '../models';
import {
    StrategyRefusalReasonsInnerFromJSON,
    StrategyRefusalReasonsInnerToJSON,
} from '../models';

export interface GetReasonsRequest {
    profileId: string;
}

/**
 * 
 */
export class ProfileStrategyRefusalReasonsApi extends runtime.BaseAPI {

    /**
     * Returns all of the reasons to refuse an application into the strategy vertical
          */
    async getReasonsRaw(requestParameters: GetReasonsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<StrategyRefusalReasonsInner>>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getReasons().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<StrategyRefusalReasonsInner>>({
            path: `/profile/api/{profileId}/strategy-refusal-reasons`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(StrategyRefusalReasonsInnerFromJSON);
        return response;
    }

    /**
     * Returns all of the reasons to refuse an application into the strategy vertical
          */
    async getReasons(requestParameters: GetReasonsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<StrategyRefusalReasonsInner>> {
        const response = await this.getReasonsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
